import create from "zustand";
import { persist } from "zustand/middleware";

export type meterPorps = {
  monitorid: string; //表计序号
  monitortype: string; //表计厂商
  comaddress: string; //表编号
  buildingid: string; //建筑编号
  roomid: string; //厂商建筑编号
  totalpurchaseamount: string; //总购量
  totalusedamount: string; //总用量
  remainingamount: number; //剩余金额
  remainingquanlity: string; //剩余量
  energyType: string; //表类型 （电表，冷水表，热水表）
  updateTime: string; //数据更新时间: string
};
export interface meterSettingProps {
  allowChargeEndTime: string; //充值时间-结束
  allowChargeStartTime: string; //充值时间-开始
  coldWaterPrice: string; //冷水表单价
  electricityPrice: string; //电表单价
  hotWaterPrice: string; // 热水单价
}

export interface waringMoneyProps {
  eleWarnMoney1?: string | null; //
  eleWarnMoney2?: string | null; //
  coldWaterWarnMoney1?: string | null; //
  coldWaterWarnMoney2?: string | null; //
  hotWaterWarnMoney1?: string | null; //
  hotWaterWarnMoney2?: string | null; //
}
export interface userInfoProps {
  username: string;
  token: string;
  tokenExpireAt?: number; // XCX-Token 过期时间戳（毫秒），登录时由后端返回的 expire(秒) 换算
  buildingName: string;
  buildingNameEN: string;
  nkdSid?: string;
  buildingid: string;
  buildingName1: string;
  buildingName2: string;
  buildingIsDisplayed: number;
  meterList: Record<string, any>;
  meterSetting: meterSettingProps;
  waringMoney: waringMoneyProps;
  buildingType: string; // 21005 是老师，其余学生
  allowfraction: number  //1可以小数，0是整数
  updateToken: (val: string) => void;
  updateTokenExpireAt: (val: number) => void;
  updatenKdSid: (val: string) => void;
  updateBuildingid: (val: string) => void;
  updateBuildingName: (val: string) => void;
  updatebuildingNameEN: (val: string) => void;
  updateUserName: (val: string) => void;
  updateMeterList: (val: Record<string, any>) => void;
  updateMeterSetting: (val: meterSettingProps) => void;
  updateWaringMoney: (val: waringMoneyProps) => void;
  updateBuildingType: (val: string) => void;
  updateisDisplayed: (val: number) => void;
  updateallowfraction: (val: number) => void;
  updateBuildingName1: (val: string) => void;
  updateBuildingName2: (val: string) => void;
}
export const useStore = create<userInfoProps>()(
  persist(
    (set, get) => ({
      token: "",
      tokenExpireAt: 0,
      buildingName: "",
      buildingNameEN: "",
      buildingid: "",
      buildingName1: '',
      buildingName2: '',
      buildingIsDisplayed: 1,
      allowfraction: 0,
     // nkdSid:'88888885',
      nkdSid: "",
      username: "",
      meterList: [],
      buildingType: "",
      meterSetting: {} as meterSettingProps,
      waringMoney: {} as waringMoneyProps,
      updateToken: (newVal: string) => set({ token: newVal }),
      updateTokenExpireAt: (newVal: number) => set({ tokenExpireAt: newVal }),
      updateBuildingid: (newVal: string) => set({ buildingid: newVal }),
      updateBuildingName: (newVal: string) => set({ buildingName: newVal }),
      updatebuildingNameEN: (newVal: string) => set({ buildingNameEN: newVal }),
      updatenKdSid: (newVal: string) => set({ nkdSid: newVal }),
      updateUserName: (newVal: string) => set({ username: newVal }),
      updateMeterList: (newVal: Record<string, any>) =>
        set({ meterList: newVal }),
      updateMeterSetting: (newVal: meterSettingProps) =>
        set({ meterSetting: newVal }),
      updateWaringMoney: (newVal: waringMoneyProps) =>
        set({ waringMoney: newVal }),
      updateBuildingType: (newVal: string) => set({ buildingType: newVal }),
      updateBuildingName1: (newVal: string) => set({ buildingName1: newVal }),
      updateBuildingName2: (newVal: string) => set({ buildingName2: newVal }),
      updateallowfraction: (newVal: number) => set({ allowfraction: newVal }),
      updateisDisplayed: (newVal: number) =>
        set({ buildingIsDisplayed: newVal }),
    }),
    {
      name: "nkd-storage",
    }
  )
);
